/**
 * Formats des matricules (ADR-003, ADR-004).
 *
 * La GÉNÉRATION se fait exclusivement côté backend avec un générateur
 * cryptographique (`crypto.randomInt`). Ce module ne fournit que l'alphabet,
 * les longueurs et la validation de format, partagés avec les frontends.
 */
/** Majuscules + chiffres sans 0, O, 1, I, L (31 symboles). */
export const MATRICULE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
export const APPLICATION_SUFFIX_LENGTH = 6;
export const USER_NUMBER_LENGTH = 8;
export const USER_NUMBER_PREFIX = 'CAN';
const A = `[${MATRICULE_ALPHABET}]`;
/** Préfixe de concours : 2 à 6 lettres majuscules (ex. PEN). */
export const COMPETITION_PREFIX_REGEX = /^[A-Z]{2,6}$/;
/** Ex. PEN-2026-A7K9Q2 */
export const APPLICATION_NUMBER_REGEX = new RegExp(`^[A-Z]{2,6}-\\d{4}-${A}{${APPLICATION_SUFFIX_LENGTH}}$`);
/** Ex. CAN-7K9Q2A4M */
export const USER_NUMBER_REGEX = new RegExp(`^${USER_NUMBER_PREFIX}-${A}{${USER_NUMBER_LENGTH}}$`);
export function isApplicationNumber(value) {
    return APPLICATION_NUMBER_REGEX.test(value);
}
export function isUserNumber(value) {
    return USER_NUMBER_REGEX.test(value);
}
/** Normalise une saisie utilisateur (espaces, minuscules) avant recherche. */
export function normalizeMatricule(value) {
    return value.trim().toUpperCase().replace(/\s+/g, '');
}
//# sourceMappingURL=matricules.js.map